import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { ArrowRightIcon } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';
import { usePricing } from '../contexts/PricingContext';
import { ContactFormPopup } from './ContactFormPopup';
export function HeroVariant71() {
  const {
    language
  } = useLanguage();
  const {
    price
  } = usePricing();
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const content = {
    ru: {
      cta: 'Получить макет'
    },
    ua: {
      cta: 'Отримати макет'
    },
    en: {
      cta: 'Get a mockup'
    }
  }[language] || content.ru;
  return <>
      <section className="relative min-h-screen w-full flex flex-col items-center justify-center px-4 pt-20 pb-12 bg-[#F8F9FA]" data-id="element-956">
        <div className="max-w-5xl mx-auto text-center flex flex-col items-center" data-id="element-957">
          <h1 className="text-5xl md:text-6xl lg:text-[5.5rem] font-medium leading-[1.2] tracking-tight text-gray-900 uppercase" data-id="element-958">
            Создаем уникальные сайты
            <span className="inline-flex items-center justify-center mx-3 md:mx-5 align-middle w-16 h-16 md:w-20 md:h-20 bg-blue-100 rounded-full text-4xl md:text-5xl shadow-sm transform -rotate-12" data-id="element-959">
              🚀
            </span>
            для клиентов,
            <br data-id="element-960" />
            нужно оплачивать
            <span className="inline-flex items-center justify-center mx-3 md:mx-5 align-middle w-16 h-16 md:w-20 md:h-20 bg-green-100 rounded-full text-4xl md:text-5xl shadow-sm transform rotate-12" data-id="element-961">
              💸
            </span>
            только за обслуживание
            <br data-id="element-962" />
            всего лишь
            <span className="inline-flex items-center justify-center mx-3 md:mx-5 align-middle px-6 py-2 bg-gray-900 text-white rounded-full text-3xl md:text-5xl font-bold shadow-lg transform -rotate-3" data-id="element-963">
              {price}
            </span>
            в месяц
          </h1>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: 0.4
        }} className="mt-16" data-id="element-964">
            <button onClick={() => setIsPopupOpen(true)} className="group flex items-center justify-center gap-2 rounded-full px-10 py-5 font-bold text-lg transition-all hover:scale-105 bg-gray-900 text-white shadow-xl" data-id="element-965">
              {content.cta}
              <ArrowRightIcon className="w-5 h-5 transition-transform group-hover:translate-x-1" data-id="element-966" />
            </button>
          </motion.div>
        </div>
      </section>
      <ContactFormPopup isOpen={isPopupOpen} onClose={() => setIsPopupOpen(false)} data-id="element-967" />
    </>;
}